import { FC } from 'react';
import { Position } from '../../types/enums';
import { LabelProps } from './types/propTypes';
import styles from './Label.module.scss';

export const Label: FC<LabelProps> = (props: LabelProps) => {
  const { title, value, position = Position.VERTICAL } = props;
  return (
    <div
      data-testid="label-container"
      className={position === Position.HORIZONTAL ? styles['horizontal-display'] : styles['']}
    >
      <span className={styles['title']}>{title}</span>
      {position === Position.HORIZONTAL ? <div className={styles['two-dots']}>:</div> : null}
      <div
        className={position === Position.HORIZONTAL ? styles['value-horizontal'] : styles['value-vertical']}
        data-testid="value-container"
      >
        {value ?? ''}
      </div>
    </div>
  );
};

export default Label;
export type { LabelProps };
